import VueRouter from 'vue-router';

export default function (router: VueRouter, message: string) {
  router.push({
    name: '401',
    params: { message: message }
  });
}
